export const iconFontAwesomeHouseholdToiletPaperSlash = (
	<i className="fa-solid fa-toilet-paper-slash"></i>
);
